(function () {
  if (window.__wfCartHeaderAccountBound) return;
  window.__wfCartHeaderAccountBound = true;

  function openAccountMenu(control) {
    const host = control.nextElementSibling?.matches('shopify-account.wf-cart-header-account__host')
      ? control.nextElementSibling
      : control.parentElement?.querySelector('shopify-account.wf-cart-header-account__host');

    const trigger = host?.shadowRoot?.querySelector(
      'button.account-button, button[part="signed-out-avatar"], button[part="signed-in-avatar"]'
    );

    trigger?.click();
  }

  function syncCartHeaderAccountOffset() {
    const header = document.querySelector('.wf-header--cart');
    if (!header) return;

    const anchor =
      document.querySelector('#main-cart-items .wf-cart-checkout-panel') ||
      document.querySelector('#main-cart-items');

    if (!anchor) {
      document.documentElement.style.removeProperty('--wf-cart-header-account-right');
      return;
    }

    const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
    const offset = Math.max(0, Math.round(viewportWidth - anchor.getBoundingClientRect().right));
    document.documentElement.style.setProperty('--wf-cart-header-account-right', offset + 'px');
  }

  function bindCartHeaderAccountSync() {
    syncCartHeaderAccountOffset();

    if (window.__wfCartHeaderAccountSyncBound) return;
    window.__wfCartHeaderAccountSyncBound = true;

    window.addEventListener('resize', syncCartHeaderAccountOffset, { passive: true });
    window.addEventListener('load', syncCartHeaderAccountOffset);
    document.addEventListener('eurus:cart:items-changed', syncCartHeaderAccountOffset);

    const anchor = document.querySelector('#main-cart-items');
    if (anchor && typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(syncCartHeaderAccountOffset);
      observer.observe(anchor);
    }
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest('button.wf-cart-header-account');
    if (!control) return;

    event.preventDefault();
    openAccountMenu(control);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartHeaderAccountSync);
  } else {
    bindCartHeaderAccountSync();
  }
})();
